import { useState } from "react";
import * as v from "valibot";
import { useLang } from "../../../services/lang";
import { useUser, UserInput } from "../../../components/User";
import { api, handleError } from "../../../services/api";
import { getLocalId } from "easy-analytics/client";
import { Input } from "../../../components/Form";
import { Loading } from "../../../components";
import { UserSchema } from "../../../services/checkData";
import { WhoClient, Vote, VoteFull } from "../../../../types";

type EmptyVote = Omit<VoteFull, "vote"> & {
    vote: Vote | "",
}

export function WhoVoting({ who, vote, onChange }: { who: WhoClient, vote: null | VoteFull, onChange: (message: string) => void }) {
    const { dict } = useLang();
    const { user } = useUser();

    const [voteEdit, setVoteEdit] = useState<EmptyVote>(vote || { vote: "", comment: "" });
    const [message, setMessage] = useState("");
    const [isSending, setIsSending] = useState(false);

    async function handleSave() {
        if (!v.safeParse(UserSchema, user).success) {
            setMessage(dict.userNameMissing);
            return;
        }

        if (!voteEdit.vote) {
            setMessage(dict.whoVoteMissing);
            return;
        }

        setIsSending(true);
        const [, error] = await api.updateWhoVote({
            whoId: who._id,
            vote: voteEdit as VoteFull,
            userId: getLocalId(),
            user,
        });
        setIsSending(false);

        if (error) {
            handleError(error);
            setMessage(dict.whoVoteError);
            return;
        }

        const message = dict.whoVoteSuccess;
        setMessage(message);
        onChange(message);
    }

    const sendMessage = !v.safeParse(UserSchema, user).success ? dict.userNameMissing
        : !voteEdit.vote ? dict.whoVoteMissing
            : "";

    return <div className="width-max">
        <UserInput />

        <div className="who-votes vote">
            <div className={`who-vote vote-yes ${voteEdit.vote === "yes" ? "active selected" : ""}`} onClick={() => setVoteEdit({ ...voteEdit, vote: "yes" })}>{dict.yes}</div>
            {who.isMaybeOption && <div className={`who-vote vote-maybe ${voteEdit.vote === "maybe" ? "active selected" : ""}`} onClick={() => setVoteEdit({ ...voteEdit, vote: "maybe" })}>{dict.maybe}</div>}
            <div className={`who-vote vote-no ${voteEdit.vote === "no" ? "active selected" : ""}`} onClick={() => setVoteEdit({ ...voteEdit, vote: "no" })}>{dict.no}</div>
        </div>

        <Input
            type="textarea"
            value={voteEdit}
            field="comment"
            setValue={setVoteEdit}
            label={dict.whoVoteComment}
            maxLength={400}
        />
        <div style={{ marginBottom: 20 }} />

        {message && <p className="alert">{message}</p>}

        {isSending && <Loading />}
        {!isSending && <>
            {sendMessage && <p className="info">{sendMessage}</p>}
            <button disabled={!!sendMessage} className="width" onClick={handleSave}>{dict.whoVoteSend}</button>
        </>}
    </div>;
}
